import { parse, unparse } from "papaparse";

const EQUIPMENT_EXPORT_CSV_HEADER_RENAMES: Record<string, string> = {
  Age: "Age (Years)",
  "Age (year)": "Age (Years)",
  "Replacement Schedule": "Replacement Schedule (Years)",
  "Replacement Schedule (year)": "Replacement Schedule (Years)",
  "Useful Life Remaining": "Useful Life Remaining (Years)",
  "Useful Life Remaining (year)": "Useful Life Remaining (Years)",
  "Remaining Useful Life": "Remaining Useful Life (Years)",
  "Remaining Useful Life (year)": "Remaining Useful Life (Years)",
};

function formatEquipmentExportCsvHeader(header: string): string {
  return EQUIPMENT_EXPORT_CSV_HEADER_RENAMES[header] ?? header;
}

export function formatEquipmentExportCsvHeaders(headers: string[]): string[] {
  return headers.map(formatEquipmentExportCsvHeader);
}

export function formatEquipmentExportCsv(csvText: string): string {
  const { data, meta } = parse<Record<string, string>>(csvText, {
    header: true,
    skipEmptyLines: true,
    transformHeader: formatEquipmentExportCsvHeader,
  });

  if (!meta.fields?.length) {
    return csvText;
  }

  return unparse(data, { columns: meta.fields });
}
